import React from 'react';

const ImportContacts = ({ isActive }) => {
    return (
        <>
            <div style={{ padding: '2rem' }}>
                <h3>Import Contacts</h3>
                <p style={{ color: '#64748b', marginBottom: '2rem' }}>
                    Upload a CSV file to import customers or suppliers in bulk.
                </p>

                <div className="import-area inline-card" style={{
                    border: '2px dashed #cbd5e1',
                    borderRadius: '8px',
                    padding: '3rem',
                    textAlign: 'center',
                    background: '#f8fafc',
                    cursor: 'pointer'
                }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📂</div>
                    <p>Drag and drop your CSV file here or click to browse</p>
                    <button className="control-btn-primary" style={{ marginTop: '1rem' }}>
                        Select File
                    </button>
                </div>

                <div style={{ marginTop: '2rem' }}>
                    <h4>Instructions:</h4>
                    <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem', color: '#475569', lineHeight: '1.6' }}>
                        <li>Download the sample CSV file to see the required format.</li>
                        <li>Ensure emails are unique.</li>
                        <li>Contact Type should be either 'customer' or 'supplier'.</li>
                    </ul>
                    <button className="export-btn" style={{ marginTop: '1rem' }}>
                        <i className="fa fa-download"></i> Download Sample CSV
                    </button>
                </div>
            </div>
        </>
    );
};

export default ImportContacts;
